import { render, staticRenderFns } from "./InsuranceTargets.vue?vue&type=template&id=0ce63eac&scoped=true"
import script from "./InsuranceTargets.vue?vue&type=script&lang=js"
export * from "./InsuranceTargets.vue?vue&type=script&lang=js"
import style0 from "./InsuranceTargets.vue?vue&type=style&index=0&id=0ce63eac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce63eac",
  null
  
)

export default component.exports